import React from "react";
import Header from "./Header";
import Particles from "./Particles";

const Home = () => {
  return (
    <>
      <Header />
      <Particles />
    </>
  );
};

export default Home;
